import React, { ChangeEventHandler } from 'react';

import { Link } from 'react-router-dom';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import { riskConfig } from 'components/Dashboards/ExcellenceApps/riskConfig';
import { Select } from 'components/DesignSystem/Select';
import { InputOption } from 'components/DesignSystem/Select/components/InputOption/InputOption';
import { ValueContainer } from 'components/DesignSystem/Select/components/ValueContainer/ValueContainer';
import { Switch } from 'components/DesignSystem/Switch';
import { TextInput } from 'components/DesignSystem/TextInput/TextInput';
import classes from 'components/widgets/FinishDateFuturePotentialDelayDrivers/components/FinishDateFuturePotentialDelayDrivers.module.scss';
import {
    morefilterItems,
    statusOptions,
} from 'components/widgets/FinishDateFuturePotentialDelayDrivers/components/FinishDateFuturePotentialDelayDrivers.utils';

interface Props {
    handleOnSearch: (value: string) => void;
    dateFilter: ISelectOption<string> | null;
    handleDateFilter: (value: ISelectOption<string> | null) => void;
    months: ISelectOption<string>[];
    handleStatus: (value: readonly ISelectOption<string>[]) => void;
    handleStatusType: (value: readonly ISelectOption<string>[]) => void;
    statusFilter: readonly ISelectOption<string>[];
    typeFilter: readonly ISelectOption<string>[];
    handleCriticalPath: ChangeEventHandler<HTMLInputElement>;
    isCriticalPath: boolean;
    handleDelayDriver: ChangeEventHandler<HTMLInputElement>;
    isDelayDriver: boolean;
}

export const CriticalAnalysisDelayDriversFilter = ({
    handleOnSearch,
    dateFilter,
    handleDateFilter,
    months,
    handleStatusType,
    statusFilter,
    handleStatus,
    typeFilter,
    handleCriticalPath,
    isCriticalPath,
    handleDelayDriver,
    isDelayDriver,
}: Props) => {
    const linkToCriticalityRisk = () => {
        return AppRoutes.buildPath(AppRoutes.DASHBOARD_RISK_APPS_PATH, riskConfig.criticalityAnalysis.link);
    };

    const [search, setSearch] = React.useState('');

    const handleClearSearch = () => {
        setSearch('');
        handleOnSearch('');
    };

    const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.code === 'Enter' || e.code === 'NumpadEnter') {
            handleOnSearch(search);
        }
    };

    const handleClick = () => {
        handleOnSearch(search);
    };

    return (
        <div className={classes.filtersAndLinkContainer}>
            <div className={classes.filterWrapper}>
                <div className={classes.title}>Name</div>
                <div className={classes.filterTextSearch}>
                    <TextInput
                        placeholder={'Search Activities by Name'}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        onClear={handleClearSearch}
                        maxLength={200}
                        onKeyDown={onKeyDown}
                        className={classes.textInput}
                        searchable={true}
                        onSearch={handleClick}
                    />
                </div>

                <div className={classes.selectWrapper}>
                    <div className={classes.title}>Month</div>
                    <Select<ISelectOption<string>> value={dateFilter} options={months} onChange={handleDateFilter} />
                </div>
                <div className={classes.selectWrapper}>
                    <div className={classes.title}>Status</div>
                    <Select<ISelectOption<string>, true>
                        id={'status-filter'}
                        value={statusFilter}
                        options={statusOptions}
                        onChange={handleStatusType}
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        isMulti={true}
                        placeholder={'Select Status...'}
                        components={{
                            Option: InputOption,
                            ValueContainer: ValueContainer,
                        }}
                    />
                </div>
                <div>
                    <Switch
                        onChange={handleDelayDriver}
                        checked={isDelayDriver}
                        label={'Delay Driver'}
                        labelPlacement={'start'}
                    />
                </div>
                <div>
                    <Switch
                        onChange={handleCriticalPath}
                        checked={isCriticalPath}
                        label={'Critical Path Only'}
                        labelPlacement={'start'}
                    />
                </div>
                <div className={classes.selectWrapper}>
                    <div className={classes.title}>More Filters</div>
                    <Select<ISelectOption<string>, true>
                        value={typeFilter}
                        options={morefilterItems}
                        onChange={handleStatus}
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        isMulti={true}
                        placeholder={'Select More Filters...'}
                        components={{
                            Option: InputOption,
                            ValueContainer: ValueContainer,
                        }}
                    />
                </div>
            </div>
            <div className={classes.linkContainer}>
                <Link to={linkToCriticalityRisk()}>View in {riskConfig.criticalityAnalysis.title}</Link>
            </div>
        </div>
    );
};
